import React from 'react';
import { ZapIcon, ShieldIcon, LeafIcon, BanIcon, TimerIcon } from 'lucide-react';
import { BENEFITS, IMAGES } from '../data/content';
import { Section, Reveal, Eyebrow } from './Section';
const ICONS = [ZapIcon, ShieldIcon, LeafIcon, BanIcon, TimerIcon];
export function Benefits() {
  return <Section className="py-16 md:py-20" data-id="element-14" data-mp="3vr8orufe7957">
      <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-16" data-id="element-15" data-mp="3vq7azi6zs8js">
        <Reveal data-id="element-16" data-mp="3qsp0voh8nna7">
          <div className="overflow-hidden rounded-[2rem] border border-forest/10 shadow-xl" data-id="element-17" data-mp="3qt76hbpsjdus">
            <img src={IMAGES.benefits} alt="A woman holding a Medufit daily nutrition canister in natural light" className="h-full w-full object-cover" data-id="element-18" data-mp="3mp99b6k10d4d" />
          </div>
        </Reveal>

        <Reveal delay={0.12} data-id="element-19" data-mp="3cu7im6a3r2zo">
          <Eyebrow data-id="element-20" data-mp="1g049dem4a2zw">The Benefits</Eyebrow>
          <h2 className="mt-5 font-serif text-3xl font-medium leading-tight text-forest sm:text-4xl lg:text-[2.75rem]" data-id="element-21" data-mp="1fyt9vqzpfhel">
            A ritual that gives back
          </h2>
          <div className="mt-8 space-y-5" data-id="element-22" data-mp="2q4vjhx7amw6">
            {BENEFITS.map((b, i) => {
            const Icon = ICONS[i];
            return <div key={b.title} className="flex items-start gap-4" data-id="element-23" data-mp="6qgfstlnil74" data-mpi={i}>
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-forest/8 text-forest" data-id="element-24" data-mp="3ozz3s6k2gl43">
                    <Icon className="h-5 w-5" data-id="element-25" data-mp="3tzc2ppo7pin1" />
                  </span>
                  <div data-id="element-26" data-mp="li7gh5gvkpc8">
                    <h3 className="font-serif text-xl text-forest" data-id="element-27" data-mp="lk1s1t69b53n">{b.title}</h3>
                    <p className="mt-0.5 text-sm text-forest/70" data-id="element-28" data-mp="qfz7zydly9fw">{b.desc}</p>
                  </div>
                </div>;
          })}
          </div>
        </Reveal>
      </div>
    </Section>;
}